"use client";
import { useEffect, useState } from "react";
import axios from "axios";
import { FaSave, FaPlus, FaTrash } from "react-icons/fa";
import "../styles/raspadinhaAdmin.css";

const API = "https://api.ticketdovaqueiro.com/api";

export default function RaspadinhaAdmin() {
  const [eventos, setEventos] = useState([]);
  const [eventoId, setEventoId] = useState("");
  const [categoria, setCategoria] = useState("");
  const [config, setConfig] = useState(null);

  const [preco, setPreco] = useState(0);
  const [ativo, setAtivo] = useState(true);
  const [premiacaoHabilitada, setPremiacaoHabilitada] = useState(true);

  // novo: lista de prêmios
  const [premios, setPremios] = useState([
    { nome: "", imagemUrl: "", probPercent: 0 },
  ]);

  // 🔹 Carregar eventos
  useEffect(() => {
    axios
      .get(`${API}/events`)
      .then((res) => setEventos(res.data || []))
      .catch((err) => console.error("Erro ao carregar eventos:", err));
  }, []);

  // carregar config
  async function carregarConfig() {
    if (!eventoId || !categoria) return;
    try {
      const res = await axios.get(`${API}/raspadinha/config`, {
        params: { eventoId, categoria },
      });
      const cfg = res.data || null;
      setConfig(cfg);
      if (cfg) {
        setPreco(Number(cfg.preco || 0));
        setAtivo(Boolean(cfg.ativo));
        setPremiacaoHabilitada(Boolean(cfg?.premiacaoHabilitada ?? true));

        // se existir cfg.premios, usa; senão, preenche a partir do legado
        if (Array.isArray(cfg.premios) && cfg.premios.length > 0) {
          setPremios(
            cfg.premios.map((p) => ({
              nome: p.nome || "",
              imagemUrl: p.imagemUrl || "",
              probPercent: Number(p.probPercent || 0),
            }))
          );
        } else {
          setPremios([
            {
              nome: cfg.nomePremio || "",
              imagemUrl: cfg.imagemPremioUrl || "",
              probPercent: 0, // sem prob (legado)
            },
          ]);
        }
      } else {
        setPreco(0);
        setAtivo(true);
        setPremios([{ nome: "", imagemUrl: "", probPercent: 0 }]);
      }
    } catch (err) {
      console.error("Erro ao carregar config raspadinha:", err);
    }
  }

  function addPremio() {
    setPremios((prev) => [...prev, { nome: "", imagemUrl: "", probPercent: 0 }]);
  }
  function rmPremio(idx) {
    setPremios((prev) => prev.filter((_, i) => i !== idx));
  }
  function setPremio(idx, patch) {
    setPremios((prev) => prev.map((p, i) => (i === idx ? { ...p, ...patch } : p)));
  }

  async function salvarConfig() {
    try {
      const soma = premios.reduce((acc, p) => acc + Number(p.probPercent || 0), 0);
      if (soma > 100 + 1e-9) {
        alert("A soma das probabilidades não pode exceder 100%.");
        return;
      }
      const body = {
        eventoId,
        categoria,
        preco: Number(preco || 0),
        ativo: Boolean(ativo),
        premiacaoHabilitada: Boolean(premiacaoHabilitada),
        premios: premios.map((p) => ({
          nome: p.nome,
          imagemUrl: p.imagemUrl,
          probPercent: Number(p.probPercent || 0),
        })),
      };
      await axios.post(`${API}/raspadinha/config`, body);
      alert("Configuração salva!");
      carregarConfig();
    } catch (err) {
      console.error("Erro ao salvar config raspadinha:", err);
      alert("Falha ao salvar configuração.");
    }
  }

  return (
    <div className="raspadinha-admin">
      <h1>🎟️ Raspadinha do Vaqueiro</h1>

      {/* Seleção de evento e categoria */}
      <div className="raspadinha-section raspadinha-grid">
        <div className="raspadinha-field">
          <label className="raspadinha-label">Evento</label>
          <select
            value={eventoId}
            onChange={(e) => {
              setEventoId(e.target.value);
              setCategoria("");
              setConfig(null);
            }}
          >
            <option value="">Selecione o evento</option>
            {eventos.map((ev) => (
              <option key={ev._id} value={ev._id}>
                {ev.nome}
              </option>
            ))}
          </select>
        </div>

        <div className="raspadinha-field">
          <label className="raspadinha-label">Categoria</label>
          <select
            value={categoria}
            onChange={(e) => setCategoria(e.target.value)}
            disabled={!eventoId}
          >
            <option value="">Selecione a categoria</option>
            {eventos
              .find((ev) => ev._id === eventoId)
              ?.categorias?.map((cat) => (
                <option key={cat.nome} value={cat.nome}>
                  {cat.nome}
                </option>
              ))}
          </select>
        </div>

        <div className="raspadinha-field">
          <label className="raspadinha-label">&nbsp;</label>
          <button onClick={carregarConfig} className="btn-primary">
            Carregar
          </button>
        </div>
      </div>

      {/* Form principal */}
      {eventoId && categoria && (
        <>
          <div className="raspadinha-section raspadinha-grid">
            <div className="raspadinha-field">
              <label className="raspadinha-label">Preço da Raspadinha</label>
              <input
                type="number"
                value={preco}
                onChange={(e) => setPreco(e.target.value)}
                min={0}
              />
            </div>

            <div className="raspadinha-field">
              <label className="raspadinha-label">Ativo</label>
              <input
                type="checkbox"
                checked={ativo}
                onChange={(e) => setAtivo(e.target.checked)}
              />
            </div>
            <div className="raspadinha-field">
              <label className="raspadinha-label">Premiação habilitada</label>
              <input
                type="checkbox"
                checked={premiacaoHabilitada}
                onChange={(e) => setPremiacaoHabilitada(e.target.checked)}
              />
              <small style={{color:"var(--ty-text-dim)"}}>
                Desative para manter o visual dos prêmios na raspagem mas sem chance de ganhar.
              </small>
            </div>
          </div>

          {/* Lista de prêmios */}
          <div className="raspadinha-section">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <h3 style={{ margin: 0, color: "var(--ty-primary)" }}>Prêmios e Probabilidades</h3>
              <button className="btn-primary" onClick={addPremio}>
                <FaPlus style={{ marginRight: 8 }} /> Adicionar prêmio
              </button>
            </div>

            {premios.map((p, idx) => (
              <div key={idx} className="raspadinha-grid" style={{ alignItems: "end", marginBottom: 10 }}>
                <div className="raspadinha-field">
                  <label className="raspadinha-label">Nome do prêmio</label>
                  <input
                    value={p.nome}
                    onChange={(e) => setPremio(idx, { nome: e.target.value })}
                    placeholder="Ex: Moto 0km"
                  />
                </div>

                <div className="raspadinha-field">
                  <label className="raspadinha-label">Imagem (URL)</label>
                  <input
                    value={p.imagemUrl}
                    onChange={(e) => setPremio(idx, { imagemUrl: e.target.value })}
                    placeholder="https://..."
                  />
                </div>

                <div className="raspadinha-field">
                  <label className="raspadinha-label">Probabilidade (%)</label>
                  <input
                    type="number"
                    min={0}
                    max={100}
                    value={p.probPercent}
                    onChange={(e) => setPremio(idx, { probPercent: e.target.value })}
                    placeholder="0-100"
                  />
                </div>

                <div className="raspadinha-field">
                  <label className="raspadinha-label">&nbsp;</label>
                  <button className="btn" onClick={() => rmPremio(idx)}>
                    <FaTrash style={{ marginRight: 6 }} /> Remover
                  </button>
                </div>
              </div>
            ))}

            <div style={{ marginTop: 12, color: "#b0b0b0", fontSize: 13 }}>
              Dica: a soma das probabilidades pode ser menor que 100%. O restante será "sem prêmio".
            </div>
          </div>

          <div className="raspadinha-section">
            <button onClick={salvarConfig} className="btn-primary" style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <FaSave /> Salvar
            </button>
          </div>
        </>
      )}
    </div>
  );
}
